const qualification_data = [
  {
    id: 1,
    title: "High-School",
    institute: "Maharishi Vidya Mandir(CBSE)",
    location: "Sultanpur, U.P.",
    year: "2018-19",
    percentage: "96.4%",
    site: "https://mvmsultanpur.org/",
    img:"https://mvmsultanpur.org/upload/infrastructure/mvm-sultanpur-infrastructure(8).jpg"
  },
  {
    id: 2,
    title: "Intermediate",
    institute: "Maharishi Vidya Mandir(CBSE)",
    location: "Sultanpur, U.P.",
    year: "2020-21",
    percentage: "96.6%",
    site: "https://mvmsultanpur.org/",
    img:"https://mvmsultanpur.org/upload/infrastructure/mvm-sultanpur-infrastructure(8).jpg"
  },
  {
    id: 3,
    title: "B.Tech (CSE)",
    institute: "JSS Academy of Technical Education(AKTU)",
    location: "Noida, U.P.",
    year: "2021-25 (Pursuing)",
    percentage: "8.8 SGPA (Currently)",
    site:"https://jssaten.ac.in/",
    img:"https://infoadmission.com/wp-content/uploads/2020/03/jss-academy-1024x570-1.jpg"
  },
];

export default qualification_data;
